// Models
import { IExerciseData } from 'storage/exercise/models'
import { IWorkoutSetInput } from 'models'
import { TMenuDropdownOption } from 'heeds-ds/src/models'

// React
import { FC, useContext } from 'react'

// Libraries
import { ThemeContext } from 'styled-components'

// Components
import * as Styled from './styled'
import { Aligner, DropdownMenu, IconButton, InputText } from 'heeds-ds'
import { Exercise } from 'components'

type Props = {
  onClickImage?: (exercise: IExerciseData) => void
  prefix: string
  removeWorkoutSet?: (setId: string) => void
  workoutSet?: IWorkoutSetInput
}

const ExerciseRow: FC<Props> = ({
  onClickImage,
  prefix,
  removeWorkoutSet,
  workoutSet,
}) => {
  const theme = useContext(ThemeContext)

  const handleDeleteWorkoutSet = () => {
    removeWorkoutSet && workoutSet && removeWorkoutSet(workoutSet?.id)
  }

  const workoutOptions: TMenuDropdownOption[] = [
    {
      icon: 'delete',
      label: 'Excluir',
      onClick: handleDeleteWorkoutSet,
      color: theme.colors.icon.critical,
    },
  ]

  return (
    <Styled.Row>
      <Styled.Cell>
        <Aligner data-testid="exerciseRow" width="384px" flex="column">
          {workoutSet?.exercises.map((setToExercise) => {
            return (
              <Exercise
                key={setToExercise.id}
                comments={workoutSet.comments}
                exercise={setToExercise.exercise}
                displayMode
                onClick={() => undefined}
                onClickImage={onClickImage}
                review
              />
            )
          })}
        </Aligner>
      </Styled.Cell>

      <Styled.Cell>
        <Aligner flex="column">
          {workoutSet?.exercises.map((setToExercise) => {
            return (
              <Styled.InputWrapper
                data-testid="quantityRow"
                key={setToExercise.id}
              >
                <InputText
                  name={`${prefix}.workout_set.${workoutSet.id}.quantity`}
                  displayError={false}
                  scale="small"
                  placeholder={String(workoutSet?.quantity || '')}
                  width="80px"
                  mask="integer"
                  borderLess
                />
              </Styled.InputWrapper>
            )
          })}
        </Aligner>
      </Styled.Cell>

      <Styled.Cell>
        {workoutSet?.exercises.map((setToExercise) => {
          return (
            <Styled.InputWrapper
              data-testid="intervalRow"
              key={setToExercise.id}
            >
              <InputText
                name={`${prefix}.workout_set.${workoutSet.id}.interval`}
                displayError={false}
                scale="small"
                placeholder={String(workoutSet?.interval || '') + ' seg'}
                width="80px"
                mask="seconds"
                borderLess
              />
            </Styled.InputWrapper>
          )
        })}
      </Styled.Cell>

      <Styled.Cell>
        {workoutSet?.exercises.map((setToExercise, index) => {
          return (
            <Styled.InputWrapper
              data-testid="repetitionRow"
              key={setToExercise.id}
            >
              <InputText
                name={`${prefix}.workout_set.${workoutSet.id}.exercises.${index}.repetitions`}
                displayError={false}
                scale="small"
                placeholder={String(setToExercise?.repetitions || '0 - 0')}
                width="80px"
                mask="repetitions"
                borderLess
              />
            </Styled.InputWrapper>
          )
        })}
      </Styled.Cell>

      <Styled.Cell>
        {workoutSet?.exercises.map((setToExercise, index) => {
          return (
            <Styled.InputWrapper data-testid="weightRow" key={setToExercise.id}>
              <InputText
                name={`${prefix}.workout_set.${workoutSet.id}.exercises.${index}.weight`}
                displayError={false}
                scale="small"
                placeholder={String(setToExercise?.weight || '') + ' kg'}
                width="80px"
                mask="weight"
                borderLess
              />
            </Styled.InputWrapper>
          )
        })}
      </Styled.Cell>

      <Styled.Cell onClick={(e) => e.stopPropagation()}>
        <DropdownMenu items={workoutOptions}>
          <IconButton iconName="moreVertical" size="small" margin="0" />
        </DropdownMenu>
      </Styled.Cell>
    </Styled.Row>
  )
}

export default ExerciseRow
